import { CopyIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { useCopyToClipboard } from 'usehooks-ts'

import IconButton from '../iconButton'
import { useToast } from '../toast/useToast'

interface Props {
    value: string
    name?: string
    className?: string
    tooltip?: ReactNode
}

export default function CopyToClipboard({ value, name, className, tooltip }: Props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, copy] = useCopyToClipboard()
    const { toast } = useToast()

    const onCopyClick = () => {
        copy(value)
        toast({
            title: 'Copied!',
            description: `Copied${name ? ` ${name}` : ''} to clipboard`,
        })
    }

    tooltip ??= 'Copy to clipboard'

    return <IconButton icon={CopyIcon} className={className} onClick={onCopyClick} tooltip={tooltip} />
}
